import clsx from "clsx";
import styles from "./Tab.module.scss";

export default function Tab({ onClick, children, highlighted }) {
  const tabClass = clsx(styles.tab, {
    [styles.highlighted]: highlighted,
  });
  return (
    <button type="button" className={tabClass} onClick={onClick}>
      {children}
    </button>
  );
}
